import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { reducer } from './reducer';
import { SMSStoreEffects } from './effects';
import { StoreModule } from '@ngrx/store';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature('sms', reducer),
        EffectsModule.forFeature([SMSStoreEffects])
    ],
    providers: []
})
export class SMSStoreModule {}
